import mixpanel, { type OverridedMixpanel } from 'mixpanel-browser'

import { trackDatadogError } from '../datadog'

// 대행사 광고 성과 트래킹용 믹스패널 토큰 (클라이언트 public 토큰).
const MIXPANEL_TOKEN = process.env.NEXT_PUBLIC_MIXPANEL_TOKEN

let isInitialized = false
// 토큰 누락 리포팅은 1회만 (initMixpanel 이 track 마다 재호출되므로 스팸 방지).
let hasReportedMissingToken = false

/**
 * 믹스패널을 초기화한다. 서버 사이드·토큰 미설정 시 no-op.
 * 이미 초기화됐으면 기존 인스턴스를 그대로 반환한다.
 */
export const initMixpanel = (): OverridedMixpanel | null => {
  if (typeof window === 'undefined') return null

  if (!MIXPANEL_TOKEN) {
    // 토큰 누락이 운영에서 조용히 묻히지 않도록 Datadog 으로 리포팅하고,
    // 개발 환경에선 즉시 인지할 수 있도록 throw 한다. (운영은 graceful no-op 유지)
    if (!hasReportedMissingToken) {
      hasReportedMissingToken = true
      const error = new Error(
        'NEXT_PUBLIC_MIXPANEL_TOKEN 이 없어 Mixpanel 이 비활성화됩니다.'
      )
      trackDatadogError(error, { source: 'mixpanel', phase: 'init' })
      if (process.env.NODE_ENV === 'development') throw error
    }
    return null
  }

  if (!isInitialized) {
    mixpanel.init(MIXPANEL_TOKEN, {
      // page_view 는 라우트별로 직접 track 하므로 자동 수집 비활성화
      track_pageview: false,
      persistence: 'localStorage',
      debug: process.env.NODE_ENV === 'development',
    })
    isInitialized = true
  }

  return mixpanel
}

/**
 * 초기화된 믹스패널 인스턴스를 반환한다. 미초기화 시 null.
 */
export const getMixpanelInstance = (): OverridedMixpanel | null => {
  if (typeof window === 'undefined' || !MIXPANEL_TOKEN || !isInitialized) {
    return null
  }
  return mixpanel
}
